import {PageEvent} from '@spartacus/storefront';

export class CpqConfiguratorPageEvent extends PageEvent {}
